import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";

const ModsHd = ({ sort, sort_by, createSortHandler }) => {
	const sortLabel = (key, name) => (
		<TableSortLabel
			active={sort === key}
			direction={sort === key ? sort_by : 'asc'}
			onClick={() => createSortHandler(key)}
		>
			{name}
		</TableSortLabel>
	);

	return (
		<TableHead className="engine-module-table">
			<TableRow >
				<TableCell colSpan={11}/>
				<TableCell colSpan={1}/>
				<TableCell colSpan={3} align="center"> MOD Compliance details</TableCell>
				<TableCell colSpan={2} />
			</TableRow>
			<TableRow>
				<TableCell style={{ minWidth: '140px' }}>Action(s)</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('ata_chapter', 'ATA Chapter')}</TableCell>
				<TableCell style={{ minWidth: '180px' }}>{sortLabel('mod_ref_number', 'MOD Reference Number')}</TableCell>
				<TableCell style={{ minWidth: '140px' }}>{sortLabel('mod_issued_by', 'MOD Issued By')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('mod_applicability', 'MOD Applicability')}</TableCell>
				<TableCell style={{ minWidth: '200px' }}>{sortLabel('description', 'Description')}</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('type', 'Type')}</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('effectivity', 'Effectivity')}</TableCell>
				<TableCell style={{ minWidth: '150px' }}>{sortLabel('effectivity_date', 'Effectivity Date')}</TableCell>
				<TableCell style={{ minWidth: '170px' }}>{sortLabel('mod_interval_type', 'MOD Compliance')}</TableCell>
				<TableCell style={{ minWidth: '190px' }}>{sortLabel('mod_interval', 'MOD Compliance Period')}</TableCell>
				<TableCell style={{ minWidth: '190px' }}>{sortLabel('mod_compliance_status', 'MOD Compliance Status')}</TableCell>
				<TableCell>TSN</TableCell>
				<TableCell>CSN</TableCell>
				<TableCell>Date</TableCell>
				<TableCell style={{ minWidth: '140px' }}>MOD Next Due</TableCell>
				<TableCell style={{ minWidth: '110px' }}>Attachments</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default ModsHd;
